/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/electricity': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11.11 23a1 1 0 01-.34-.06 1 1 0 01-.65-1.05l.77-7.09H5a1 1 0 01-1-1 1 1 0 01.17-.56l7.89-11.8a1 1 0 011.82.62l-.77 7.14H19a1 1 0 011 1 1 1 0 01-.17.56l-7.89 11.8a1 1 0 01-.83.44z"/>'
  }
})
